import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { SecurityService } from './security.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private securityService: SecurityService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    /*,state: RouterStateSnapshot, */
  ): boolean {
    // Check if the user is authenticated
    const isAuthenticated = this.securityService.isAuthenticated();
    if (!isAuthenticated) {
      this.securityService.login();
      return false;
    }

    return this.checkRole(route);
  }

  // Method to check the user's role
  private checkRole(route: ActivatedRouteSnapshot): boolean {
    // Get the user's roles from the token
    const user = this.securityService.getUser();
    const userRoles = user['https://medien-haus.de/roles'];

    // Get the allowed roles for the route
    const allowedRoles = route.data['roles'] as Array<string>;

    console.log(
      JSON.stringify(userRoles) + 'in' + JSON.stringify(allowedRoles),
    );

    // Check if the user has one of the allowed roles
    if (userRoles && allowedRoles.some((role) => userRoles.includes(role))) {
      return true;
    } else {
      // Redirect to a not authorized page if the role doesn't match
      this.router.navigate(['/']);
      return false;
    }
  }
}
